import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2, CheckCircle2, AlertTriangle } from "lucide-react";
import { SiteNav } from "@/components/SiteNav";
import { api, formatError } from "@/lib/api";

export default function ConfirmReplyTo() {
  const { token } = useParams();
  const [state, setState] = useState({ status: "idle" });
  const confirm = async () => {
    setState({ status: "busy" });
    try {
      setState({ status: "done", ...(await api.post(`/org/reply-to/confirm/${token}`)).data });
    } catch (e) {
      setState({ status: "error", error: formatError(e) });
    }
  };
  return (
    <div className="min-h-screen"><SiteNav />
      <div className="max-w-lg mx-auto px-6 py-20" data-testid="confirm-reply-to-page">
        <h1 className="font-display text-3xl font-bold">Confirm reply-to inbox</h1>
        {state.status !== "done" && state.status !== "error" && (
          <>
            <p className="text-slate-600 dark:text-slate-300 mt-3">Confirm that you manage this inbox and agree to receive replies from recipients of this organisation's PostalCloud letters.</p>
            <button data-testid="confirm-reply-to-btn" onClick={confirm} disabled={state.status === "busy"} className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-emerald-600 text-white font-semibold hover:bg-emerald-500 transition-colors disabled:opacity-60">
              {state.status === "busy" && <Loader2 size={16} className="animate-spin" />} Confirm this inbox
            </button>
          </>
        )}
        {state.status === "done" && <p data-testid="confirm-reply-to-success" className="mt-6 flex gap-2 text-emerald-700"><CheckCircle2 className="shrink-0" /> {state.email} is now the reply-to inbox for {state.org_name}.</p>}
        {state.status === "error" && <p data-testid="confirm-reply-to-error" className="mt-6 flex gap-2 text-red-600 text-sm"><AlertTriangle size={16} className="shrink-0" /> {state.error}</p>}
        <Link to="/" className="inline-block mt-10 text-sm underline">PostalCloud home</Link>
      </div>
    </div>
  );
}
